/* Koleksiyon ust seridi kontrolleri
   1) Izgara sutun sayisi (masaustu + mobil) -> CSS degiskeni olarak uygulanir
   2) Model / Product gorsel degistirici -> urun listesine class eklenir
   3) Siralama acilir menusu -> mevcut filtreler korunarak listeyi yeniler

   Secimler localStorage'da hatirlanir; filtre/siralama sonrasi ust serit
   yeniden basildiginda bu element de yeniden kurulur ve secimleri geri uygular. */

if (!customElements.get('collection-view-controls')) {
  const STORAGE_KEYS = {
    grid: 'renneway:collection-grid-columns',
    gridMobile: 'renneway:collection-grid-columns-mobile',
    imageView: 'renneway:collection-image-view',
  };

  const readStore = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const writeStore = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      /* gizli sekme / dolu depo: sessizce gec */
    }
  };

  class CollectionViewControls extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);

      this.applyState();
      // Ust serit urun listesinden once basildiginda liste henuz DOM'da olmaz.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.applyState(), { once: true });
      }
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    get sectionElement() {
      return this.closest('.shopify-section') || this.closest('[id^="shopify-section-"]');
    }

    get productsList() {
      const scope = this.closest('[data-collection-wrapper]') || document;
      return scope.querySelector('.main-collection--products-list');
    }

    onChange = (event) => {
      const target = event.target;
      if (!target) return;

      if (target.matches('[data-grid-view]')) {
        writeStore(STORAGE_KEYS.grid, target.value);
        this.applyGrid(target.value, false);
        return;
      }

      if (target.matches('[data-grid-view-mobile]')) {
        writeStore(STORAGE_KEYS.gridMobile, target.value);
        this.applyGrid(target.value, true);
        return;
      }

      if (target.matches('[data-card-image-view]')) {
        writeStore(STORAGE_KEYS.imageView, target.value);
        this.applyImageView(target.value);
        return;
      }

      if (target.matches('[data-collection-sort]')) {
        this.applySort(target.value);
      }
    };

    /* --- Sutun sayisi --- */

    applyGrid(value, isMobile) {
      const columns = parseInt(value, 10);
      const section = this.sectionElement;
      if (!section || !columns) return;

      // --row_count masaustu (>=1025px), --mobile_row_count mobil izgarada kullanilir.
      section.style.setProperty(isMobile ? '--mobile_row_count' : '--row_count', columns);
    }

    /* --- Model / Product gorseli --- */

    applyImageView(value) {
      const list = this.productsList;
      if (!list) return;

      list.classList.toggle('card-image-view--second', value === 'second');
    }

    /* --- Siralama --- */

    applySort(value) {
      const params = new URLSearchParams(window.location.search);
      params.delete('page');
      if (value) {
        params.set('sort_by', value);
      } else {
        params.delete('sort_by');
      }

      // Temanin filtre motoru varsa sayfa yenilenmeden guncellenir.
      if (typeof FilterForm !== 'undefined' && typeof FilterForm.renderPage === 'function') {
        FilterForm.renderPage(params.toString());
        return;
      }

      const query = params.toString();
      window.location.search = query ? `?${query}` : '';
    }

    /* --- Kayitli secimleri geri uygula --- */

    applyState() {
      const storedGrid = readStore(STORAGE_KEYS.grid);
      const gridInputs = Array.from(this.querySelectorAll('[data-grid-view]'));
      if (storedGrid && gridInputs.length) {
        const match = gridInputs.find((input) => input.value === storedGrid);
        if (match) {
          match.checked = true;
          this.applyGrid(storedGrid, false);
        }
      }

      const storedGridMobile = readStore(STORAGE_KEYS.gridMobile);
      const mobileInputs = Array.from(this.querySelectorAll('[data-grid-view-mobile]'));
      if (storedGridMobile && mobileInputs.length) {
        const match = mobileInputs.find((input) => input.value === storedGridMobile);
        if (match) {
          match.checked = true;
          this.applyGrid(storedGridMobile, true);
        }
      }

      const storedImageView = readStore(STORAGE_KEYS.imageView);
      const imageInputs = Array.from(this.querySelectorAll('[data-card-image-view]'));
      if (imageInputs.length) {
        const value = storedImageView === 'second' ? 'second' : 'first';
        const match = imageInputs.find((input) => input.value === value);
        if (match) match.checked = true;
        this.applyImageView(value);
      }
    }
  }

  customElements.define('collection-view-controls', CollectionViewControls);
}
